export default {
  title: 'Datos del proveedor',
  contractReferenceTooltip: 'Para Bankia/Caixa, la referencia de contrato es obligatoria. El campo sólo admite una T y un máximo de 7 dígitos (Ej: T1234567)',
  contractReferenceTooltipEurobits: 'Solo cuando se factura a Bankia/Caixa. La referencia de contrato es obligatoria. El campo sólo admite una T y un máximo de 7 dígitos (Ej: T1234567)',
  invalidData: 'Los datos de proveedor registrados no son correctos. Debe actualizarlos en "Datos generales" y "Agenda"'
}
